import { MouseEventHandler } from "react";

export type LinkIconProps = {
  destination: string;
  src: string;
  alt: string;
  width: string;
  height?: string;
  target?: string;
  className?: string;
  onClick?: MouseEventHandler;
};

export default function LinkIcon({
  destination,
  src,
  alt,
  width,
  height,
  onClick,
  target = "_blank",
  className,
}: LinkIconProps) {
  return (
    <a onClick={onClick} href={destination} target={target}>
      <img
        src={src}
        alt={alt}
        width={width}
        height={height}
        className={className}
        loading="lazy"
      />
    </a>
  );
}
